import React from "react";

export function StaffManagementPage() {
  return (
    <div className="page-container">
      <div className="content">
        <h1>👔 Staff Management</h1>
        <p>Manage system staff and administrators.</p>
        <p style={{ color: "#7f8c8d", marginTop: "20px", fontSize: "14px" }}>
          Coming soon...
        </p>
      </div>
    </div>
  );
}
